<st-pager
    [labelFormat]="PagerLabelFormat.Page"
    [showFirstLast]="true"
    [pageSize]="pageSize"
    [totalCount]="totalItemCount()"
    (startIndexChange)="onStartIndexChange($event)" />
